/* Admin-only per-student discount configuration dialog.
 * Extracted from Students.js (2026-02 refactor). */
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Percent } from '@phosphor-icons/react';

export default function StudentDiscountDialog({
  open, onOpenChange, target, form, setForm, onSave, saving, language, t,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="discount-dialog">
        <DialogHeader>
          <DialogTitle className="font-outfit text-xl flex items-center gap-2">
            <Percent size={22} className="text-amber-600" />
            {language === 'en' ? 'Apply Discounts' : 'Appliquer des remises'}
          </DialogTitle>
          <DialogDescription className="font-manrope">
            {target ? `${target.first_name} ${target.last_name}` : ''}
            {' — '}
            {language === 'en'
              ? 'Admin-only. Values are percentages (0-100).'
              : 'Réservé Admin. Valeurs en pourcentage (0-100).'}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-2">
              <Label className="font-manrope">{language === 'en' ? 'Registration discount (%)' : 'Remise inscription (%)'}</Label>
              <Input
                type="number" min="0" max="100" step="1"
                value={form.registration_discount_percent}
                onChange={(e) => setForm({ ...form, registration_discount_percent: e.target.value })}
                data-testid="discount-registration-input"
              />
            </div>
            <div className="space-y-2">
              <Label className="font-manrope">{language === 'en' ? 'Re-registration discount (%)' : 'Remise réinscription (%)'}</Label>
              <Input
                type="number" min="0" max="100" step="1"
                value={form.reregistration_discount_percent}
                onChange={(e) => setForm({ ...form, reregistration_discount_percent: e.target.value })}
                data-testid="discount-reregistration-input"
              />
            </div>
          </div>
          {['tuition', 'canteen', 'transport'].map((kind) => (
            <div key={kind} className="space-y-2">
              <Label className="font-manrope">
                {language === 'en'
                  ? `${kind[0].toUpperCase() + kind.slice(1)} discount (%)`
                  : `Remise ${kind === 'tuition' ? 'scolarité' : kind === 'canteen' ? 'cantine' : 'transport'} (%)`}
              </Label>
              <Input
                type="number" min="0" max="100" step="1"
                value={form[`${kind}_discount_percent`]}
                onChange={(e) => setForm({ ...form, [`${kind}_discount_percent`]: e.target.value })}
                data-testid={`discount-${kind}-input`}
              />
            </div>
          ))}
          <div className="space-y-2">
            <Label className="font-manrope">{language === 'en' ? 'Reason (optional)' : 'Motif (optionnel)'}</Label>
            <Input
              maxLength={200}
              value={form.discount_reason}
              onChange={(e) => setForm({ ...form, discount_reason: e.target.value })}
              placeholder={language === 'en' ? 'e.g., Sibling discount' : 'ex: Remise fratrie'}
              data-testid="discount-reason-input"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="discount-cancel-btn">
            {t('cancel')}
          </Button>
          <Button
            onClick={onSave} disabled={saving}
            className="bg-amber-600 hover:bg-amber-700"
            data-testid="discount-save-btn"
          >
            {saving
              ? (language === 'en' ? 'Saving...' : 'Enregistrement...')
              : (language === 'en' ? 'Save' : 'Enregistrer')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
